
export class ServiceContractDelegation {
    constructor(
        id,
        name,
        unionId,
        unionName,
        serviceCompanyId,
        serviceCompanyName,
        serviceCompanyCIF,
        delegationId,
        delegationName,
        contactId,
        executionDate,
        startDate,
        endDate,
        deletedAt,
    ) {
        this.id = id;
        this.name = name;
        this.unionId = unionId;
        this.unionName = unionName;
        this.serviceCompanyId = serviceCompanyId;
        this.serviceCompanyName = serviceCompanyName;
        this.serviceCompanyCIF = serviceCompanyCIF;
        this.delegationId = delegationId;
        this.delegationName = delegationName;
        this.contactId = contactId;
        this.executionDate = executionDate;
        this.startDate = startDate;
        this.endDate = endDate;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
        return new ServiceContractDelegation(
            data?.id ?? null,
            data?.name ?? '',
            data?.unionServiceDelegationid ?? null,
            data?.unionServiceDelegationName ?? '',
            data?.serviceCompany?.id ?? null,
            data?.serviceCompany?.name ?? '',
            data?.serviceCompany?.CIF ?? '',
            data?.delegation?.id ?? null,
            data?.delegation?.name ?? '',
            data?.serviceContactDelegation?.id ?? null,
            data?.executionDate ?? '',
            data?.startDate ?? '',
            data?.endDate ?? '',
            data?.deletedAt ?? null
        );
    }
}